import { jarallax, jarallaxElement } from 'jarallax';

export default class Jarallax {
  constructor(element) {
    this.element = element;
    this.init();
  }

  init() {
    jarallaxElement();

    const targets = this.element.querySelectorAll('[data-jarallax-element]');

    targets.forEach(target => {
      jarallax(target, {
        speed: 0.5
      });

      this.ensureAltText(target);
    });
  }

  ensureAltText(el) {
    const img = el.tagName === 'IMG' ? el : el.querySelector('img');
    if (img && (!img.alt || img.alt.trim() === "")) {
      img.alt = "Illustration parallax indépendante";
    }
  }
}